<template>
  <div :class="`video_${widget.id}`">
    <div v-html="`<style>${options.style.css}</style>`"></div>
    <video
      v-if="!isEmbeddable"
      :class="widget.id"
      :src="options.url"
      controls
      loop
      :id="widget.id"
      :style="style"
      @loadeddata="loadVideo()"
    ></video>
    <div v-else>
      <iframe :class="widget.id" :src="buildUrl" :id="widget.id" :style="style" @load="loadVideo()"></iframe>
    </div>
    <div class="bar">
      <Spinner v-if="options.loading" id="spinner"></Spinner>
    </div>
  </div>
</template>

<script>
import WidgetMixin from './Mixin.js'
import Spinner from '@/shared/components/Spinner'
import { mapActions } from 'vuex'
import VideoHelper from '@/helpers/videoHelper'

export default {
  name: 'VideoWidget',
  i18nOptions: { keyPrefix: 'components.page-editor.widget.video' },
  mixins: [WidgetMixin],
  components: {
    Spinner,
  },
  computed: {
    style() {
      return this.options.staticVideo
        ? {
            width: `${this.options.width}px !important`,
            height: `${this.options.height}px !important`,
            maxWidth: 'unset !important',
          }
        : ''
    },
    buildUrl() {
      return VideoHelper.buildUrl(this.options.url)
    },
    isEmbeddable() {
      return VideoHelper.isEmbeddable(this.options.url)
    },
  },
  methods: {
    ...mapActions('landing', ['updateOptions']),
    togglePlayPause({ target }) {
      target.paused ? target.play() : target.pause()
    },
    loadVideo() {
      const videoWidth = document.getElementById(this.widget.id).clientWidth
      const videoHeight = document.getElementById(this.widget.id).clientHeight
      if (this.options.width !== videoWidth && this.options.height !== videoHeight) {
        this.propChanged('', {
          ...this.options,
          width: videoWidth,
          height: videoHeight,
        })
      }
      this.widget.onVideoLoaded()
    },
    propChanged(path, value) {
      this.updateOptions({
        id: this.widget.id,
        path,
        value,
      })
    },
  },
}
</script>

<style scoped lang="scss">
div[class^='video_'] {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  .no-content {
    background-color: #d6d6d6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    .video {
      max-width: 40px;
    }
    .choice-text {
      color: #4b546b;
    }
  }
  video {
    width: 100%;
  }
  iframe {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    border: none;
  }
  .bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 19;
  }
}
</style>
